import { withFormsy } from 'formsy-react';
import React, { useState } from 'react';
import Switch from "react-switch";
import { Switch as AntSwitch } from 'antd';

let SwitchFormInput = (props) => {
    const [formId] = useState(TB.guid());

    let activeStyle;
    let inactiveStyle;

    if (props.switchStyle) {
        activeStyle = {
            color: props.value ? props.switchStyle?.textColor : '#000000',
        };
        inactiveStyle = {
            fontWeight: 500,
            color: props.value ? props.switchStyle?.textColor : "#000000"
        }
    } else {
        activeStyle = {
            color: props.value ? TB.config('color.light_purple') : '#a8a8a8',
        };
        inactiveStyle = {
            fontWeight: props.value ? 'normal' : '500',
            color: props.value ? '#a8a8a8' : "#000000"
        };
    }

    return (
        <div className={'form-group form-switch'}>
            {props.label !== false && (
                <label className={props.labelClassName || "col-form-label mb-3"}>
                    {props.label}
                </label>
            )}
            <label htmlFor={formId} className="mx-2 flex flex-row items-center justify-start">
                {props.offLabel !== false && (
                    <span style={inactiveStyle} className="mr-2">{props.offLabel || 'Off'}</span>
                )}
                {props.antSwitch ? (
                    <AntSwitch
                        height={21}
                        width={48}
                        style={{ transform: [{ scaleX: .7 }, { scaleY: .7 }], marginTop: -1 }}
                        checked={props.value ? true : false}
                        onChange={(checked) => props.setValue(checked ? 1 : 0)}
                        className="react-switch"
                        id={formId}
                        disabled={props.disabled}
                    />
                ) : (
                    <Switch
                        name={props.name}
                        checked={props.value ? true : false}
                        onChange={(checked) => props.setValue(checked ? 1 : 0)}
                        onColor={props.switchStyle?.onColor || TB.config('color.light_purple')}
                        offColor={props.switchStyle?.offColor || '#e7e7e8'}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        activeBoxShadow={'0 0 1px 2px ' + (props.switchStyle?.onColor || TB.config('color.light_purple'))}
                        className="react-switch"
                        id={formId}
                        disabled={props.disabled}
                    />
                )}
                {props.onLabel !== false && (
                    <span style={activeStyle} className="ml-2">{props.onLabel || 'On'}</span>
                )}
            </label>

        </div>
    )
};

const SwitchInput = withFormsy(SwitchFormInput);

export default SwitchInput;

// PROPTYPES: You can pass in a switchStyle prop to add custom switch colors to override defaults
// switchStyle: {
//     onColor: '#2ED47A', // green
//     offColor: '#90A0B7', // dark gray
//     textColor: '#000000', // black
// }